module.exports = __webpack_public_path__ + "static/neulthumb-bfe8ed47fb04105d64df1318b90e11e6.jpg";